import { createRoute } from '@tanstack/react-router';
import { Button, VerydiaWordmark } from '@verydia/ui';
import { LogIn } from 'lucide-react';
import { rootRoute } from '../root.tsx';
import { useAuth } from '../../lib/auth/index.ts';

/**
 * The signed-out landing page.
 *
 * There is no email or password field here, and there never will be: the console
 * does not handle credentials. The button hands the browser to Cognito's hosted
 * sign-in, which is the only thing that ever sees a password (§28).
 */
function LoginPage() {
  const auth = useAuth();
  const params = new URLSearchParams(window.location.search);
  const returnTo = params.get('returnTo') ?? '/';

  return (
    <main className="grid min-h-dvh place-items-center bg-[var(--vc-surface-sunken)] px-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex justify-center">
          <VerydiaWordmark tone="surface" />
        </div>

        <div className="rounded-xl border border-[var(--vc-border)] bg-[var(--vc-surface)] p-8 shadow-sm">
          <h1 className="text-lg font-semibold text-[var(--vc-text)]">
            Sign in to Verydia Control
          </h1>
          <p className="mt-2 text-sm text-[var(--vc-text-subtle)]">
            Verydia Control is invitation-only. Accounts are created by Parallax Motion; there is no
            self-serve signup.
          </p>

          <Button
            variant="primary"
            icon={<LogIn />}
            className="mt-6 w-full justify-center"
            onClick={() => auth.signIn(returnTo)}
          >
            Continue to sign in
          </Button>

          <p className="mt-4 text-xs text-[var(--vc-text-subtle)]">
            You will be taken to our identity provider to enter your password.
          </p>
        </div>

        <p className="mt-6 text-center text-xs text-[var(--vc-text-subtle)]">
          Need access? Ask an administrator of your organization to invite you.
        </p>
      </div>
    </main>
  );
}

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
});
